/**
 * Салбарын самбарын өгөгдөл — хуудас ба мэдэгдлийн хонх ХУВААЛЦАНА.
 *
 * ⚠️ Түлхүүр `['dashboard', …]`-ээр эхэлнэ: касс борлуулалт хийсний
 *    дараа `invalidateQueries(['dashboard'])` дууддаг (`sales.tsx`) —
 *    салбарын самбар ч тэр мөчид шинэчлэгдэнэ.
 *
 * `storeId` өгөөгүй бол сервер өөрийн (эсвэл хариуцсан эхний) салбарыг
 * сонгоно — хонх ба хуудасны анхны харагдац нэг хариу хуваалцана.
 */

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api, type Envelope } from './api';
import type { BranchDashboard } from './types';

export function useBranchDashboard(storeId?: string, enabled = true) {
  return useQuery({
    queryKey: ['dashboard', 'branch', storeId ?? null],
    queryFn: () =>
      api<Envelope<BranchDashboard>>(
        `/reports/branch-dashboard${storeId ? `?storeId=${encodeURIComponent(storeId)}` : ''}`,
      ),
    enabled,
    staleTime: 60_000,
    // Салбар солиход хуудас skeleton руу үсрэхгүй
    placeholderData: keepPreviousData,
  });
}
